import { render, staticRenderFns } from "./BenefitBanner.vue?vue&type=template&id=b674ec1e"
import script from "./BenefitBanner.vue?vue&type=script&lang=js"
export * from "./BenefitBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports